import { ICustomThemeParams } from "../types/styles";



export const styleVars: ICustomThemeParams = {
    colorBlue: '#2E67BC',
    colorWhite: 'white',
    colorLtGreen: '#C9DCDF',
    colorGreen: '#7BC190',
    colorGray: '#D9D9D9',
    fsLg: '3rem',
    fsMd: '1.5rem',

    
    colorReqGray: '#9CB2B9',
    colorReqGreen: '#AADF91',
    colorReqRed: '#F87979',

}